import React from 'react';
import './Bucketandbox.css';

const Bucketandbox = () => {
    return (
        <div className="Bucketandb-container">

            <div className="Bucketandb-text">
                <h2>Difference Between Making Bucket and Box</h2>
                <p>According to the shape, it is generally divided into a square box or round bucket. The sealing structure of the round bucket is better than the square shape box, and the general thickness of the bucket is 1.6~1.8mm, the hardness is higher, and it is not easy to break. Because the sealing force of the square box is uneven, it is more difficult for making and it is easy to have leek on it.</p>
            </div>
        </div>
    );
};

export default Bucketandbox;

